export default __webpack_public_path__ + "static/peaceful-lake-ebcfed06b8f0ae8f6cd4e7be5e3d7ec1.png";